import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=07970d0f&"
import script from "./AppLogin.vue?vue&type=script&lang=ts&"
export * from "./AppLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports